"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Min(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12.582 6.701h1.485V1.946h-1.485v4.755zM21 20c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h18zm-9-10c.55 0 1 .45 1 1v4.58l1.29-1.29c.39-.39 1.03-.39 1.42 0 .39.39.39 1.03 0 1.42l-3 3a.55.55 0 0 1-.09.07c-.03.03-.07.05-.1.07-.05.03-.09.05-.14.07-.06.03-.12.05-.19.061-.06.009-.13.019-.19.019-.26 0-.51-.1-.71-.29l-3-3c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l1.29 1.3V11c0-.55.45-1 1-1zm-1.827-8.142c.964 0 1.46.583 1.486 1.75V6.7h-1.486V3.7c0-.242-.04-.42-.123-.53C9.968 3.055 9.82 3 9.602 3a.703.703 0 0 0-.655.391l.005.061v3.248H7.466V3.71c0-.249-.039-.43-.119-.54C7.27 3.055 7.118 3 6.895 3c-.284 0-.5.131-.65.391v3.31H4.763V1.945h1.39l.048.558c.337-.43.79-.646 1.357-.646.601 0 1.007.24 1.218.716.322-.477.788-.716 1.397-.716zm7.573 0c.495 0 .865.15 1.11.444.245.296.37.742.38 1.336v3.063H17.75V3.7c0-.239-.048-.416-.144-.529-.097-.113-.273-.169-.528-.169-.29 0-.506.114-.646.342v3.358H14.95V1.946h1.389l.049.558c.327-.43.78-.646 1.357-.646zM13.316 0c.243 0 .441.067.593.201a.664.664 0 0 1 .229.52.655.655 0 0 1-.229.517c-.152.136-.35.203-.593.203-.244 0-.441-.067-.593-.203a.655.655 0 0 1-.229-.517c0-.211.076-.384.229-.52.152-.134.349-.201.593-.201z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Min;
